const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[1]"
    },
     docName: {
         value: "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
    diagnosisDate : [
        {
            type: "text",
            dbqName: "F[0].Page_1[0].Diagnosis1[0]",
            dateDbqName: "F[0].Page_1[0].Dateofdiagnosis1[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_1[0].Diagnosis2[0]",
            dateDbqName: "F[0].Page_1[0].Dateofdiagnosis2[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_1[0].Diagnosis3[0]",
            dateDbqName: "F[0].Page_1[0].Dateofdiagnosis3[0]",
        }    
    ]

}

export default ssn ;